import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-expect-error --}}\n<@form.TextareaRow @name=\"articularPainLocation\" @label={{t \"ctcae-custom.articularPainLocation.long\" htmlSafe=true}} />", {
  moduleName: "core/components/ctcae-custom/base-edition-form/articular-pain-location/index.hbs"
});